
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CoursePage from "../pages/course/page";
import TeacherPage from "../pages/teacher/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/course/:id",
    element: <CoursePage />,
  },
  {
    path: "/teacher/:id",
    element: <TeacherPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
